<template>
  <v-btn class="mx-4 my-1" depressed color="primary" @click="exportExcel">
    <slot></slot>
  </v-btn>
</template>

<script>
import XLSX from "xlsx-js-style";

export default {
  props: {
    listeRules: {
      type: Array,
      default: () => [],
    },
    listeSubstances: {
      type: Array,
      default: () => [],
    },
    fileType: {
      type: String,
      default: ".xlsx",
      validator: (val) => [".xlsx", ".xls"].includes(val),
    },
  },
  methods: {
    async exportExcel() {
      // Entrées - liste d'id sub et rules
      // console.log("liste de substances :", this.listeSubstances);
      // console.log("liste de rules :", this.listeRules);

      // call de l'API pour recup clé valeur
      try {
        let url = "/rules/export";
        const response = await this.axios({
          method: "post",
          url: url,
          data: {
            liste: {
              substances: this.listeSubstances,
              rules: this.listeRules,
            },
          },
        });

        // reponses
        if (response.status === 200) {
          let subs = response.data.substances;
          let rules = response.data.rules;
          // console.log("DATA TO ANALYSE");
          // console.log(subs);
          // console.log(rules);
          this.createExcel(subs, rules);
        }
      } catch (err) {
        console.error(err);
      }
    },
    createExcel(dataArray, rulesArray) {
      // create data object
      let columnsToExportObject = {
        Theme: { Textes: ["Name", "N°CE", "N°CAS"] },
      };
      rulesArray.forEach((r) => {
        if (!columnsToExportObject[r.theme]) {
          columnsToExportObject[r.theme] = {};
        }
        if (!columnsToExportObject[r.theme][r.usual_name]) {
          columnsToExportObject[r.theme][r.usual_name] = [];
        }
        if (r.mandatory_columns.length) {
          columnsToExportObject[r.theme][r.usual_name] = [
            ...r.mandatory_columns,
          ];
        } else {
          columnsToExportObject[r.theme][r.usual_name] = ["présent"];
        }
      });
      let excelValues = dataArray.map((substance) => {
        let sub = {
          cas: substance.cas,
          ce: substance.ce,
          usual_name: substance.usual_name,
          rules: {},
        };
        substance.rules.forEach((rule) => {
          // create theme if not exist
          if (!sub.rules[rule.theme]) {
            sub.rules[rule.theme] = {};
          }

          // let importantValues = false;
          let ruleObj = {}; // obj that will be part of theme obj

          if (
            columnsToExportObject[rule.theme][rule.usual_name][0] === "présent"
          ) {
            ruleObj.présent = "X";
          } else {
            for (const [key, value] of Object.entries(rule.value)) {
              if (
                columnsToExportObject[rule.theme][rule.usual_name].indexOf(
                  key
                ) >= 0
              ) {
                ruleObj[key] = value;
              }
            }
          }
          // push rules object in the substance
          sub.rules[rule.theme][rule.usual_name] = ruleObj;
        });
        return sub;
      });
      // methode pour ajouter les textes non concernées

      // console.log("Object Column :", columnsToExportObject);
      // console.log("Object Values :", excelValues);

      ////////////////////////////////////////////
      // EXCEL FCT
      //////////////////////////

      /// Create Row ///

      // header
      let headerThemeArray = []; // pushing object data
      let headerArray = []; // pushing object data
      let columnsArray = []; // pushing object data
      let headerThemeHelper = []; // pushing name to control double
      let headerHelper = []; // pushing name to control double
      let indexHelper = [];

      // implement index Helper
      for (const [theme, rule] of Object.entries(columnsToExportObject)) {
        for (const [key, value] of Object.entries(rule)) {
          value.forEach((v) => {
            indexHelper.push(`${theme}_${key}_${v}`);
          });
        }
      }

      // ORDER INDEX HELPER AND put sub data first
      indexHelper.sort();
      const subcol = "Theme_Textes_Name";
      const cecol = "Theme_Textes_N°CE";
      const cascol = "Theme_Textes_N°CAS";
      let fromIndex = indexHelper.indexOf(subcol);
      let toIndex = 0;
      let element = indexHelper.splice(fromIndex, 1)[0];
      indexHelper.splice(toIndex, 0, element);

      fromIndex = indexHelper.indexOf(cecol);
      toIndex = 1;
      element = indexHelper.splice(fromIndex, 1)[0];
      indexHelper.splice(toIndex, 0, element);

      fromIndex = indexHelper.indexOf(cascol);
      toIndex = 2;
      element = indexHelper.splice(fromIndex, 1)[0];
      indexHelper.splice(toIndex, 0, element);

      // create header
      for (const [theme, rule] of Object.entries(columnsToExportObject)) {
        for (const [key, value] of Object.entries(rule)) {
          value.forEach((v) => {
            let i = indexHelper.indexOf(`${theme}_${key}_${v}`);
            // console.log(`${theme}_${key}_${v}`, i);
            headerThemeHelper[i] = theme;
            headerThemeArray[i] = {
              v: theme,
              s: {
                alignment: { horizontal: "center" },
                fill: { fgColor: { rgb: "E9E9E9" } },
                font: { bold: true },
                border: {
                  right: { style: "thin", color: "000000" },
                  left: { style: "thin", color: "000000" },
                  top: { style: "thin", color: "000000" },
                  bottom: { style: "thin", color: "000000" },
                },
              },
            };
            headerHelper[i] = key;
            headerArray[i] = {
              v: key,
              s: {
                alignment: { horizontal: "center" },
                fill: { fgColor: { rgb: "E9E9E9" } },
                font: { bold: true },
                border: {
                  right: { style: "thin", color: "000000" },
                  left: { style: "thin", color: "000000" },
                  top: { style: "thin", color: "000000" },
                  bottom: { style: "thin", color: "000000" },
                },
              },
            };
            columnsArray[i] = {
              v: v,
              s: {
                alignment: { horizontal: "center" },
                fill: { fgColor: { rgb: "E9E9E9" } },
                font: { bold: true },
                border: {
                  right: { style: "thin", color: "000000" },
                  left: { style: "thin", color: "000000" },
                  top: { style: "thin", color: "000000" },
                  bottom: { style: "thin", color: "000000" },
                },
              },
            };
          });
        }
      }

      /// create timestamp
      let todayDate = new Date();
      let months = todayDate.getMonth() + 1;
      months < 10 ? (months = "0" + months) : "";
      let yyyy = todayDate.getFullYear();
      let dd = todayDate.getUTCDate();
      dd < 10 ? (dd = "0" + dd) : "";
      let hh = todayDate.getHours();
      hh < 10 ? (hh = "0" + hh) : "";
      let mm = todayDate.getMinutes();
      mm < 10 ? (mm = "0" + mm) : "";
      let hours = `${hh}:${mm}`;
      let date = `${dd}/${months}/${yyyy}`;

      /// build Header
      let dataToExcel = [];

      /// Header Info
      dataToExcel.push([
        { v: "Export provenant de l'outil BDSR Web du Cetim" },
      ]);
      dataToExcel.push([{ v: `${date} (${hours})` }]);
      dataToExcel.push([]);

      /// Header Table
      dataToExcel.push(headerThemeArray);
      dataToExcel.push(headerArray);
      dataToExcel.push(columnsArray);

      /// values

      /// sort substances by usual name
      let array = [...excelValues];
      function compare(a, b) {
        if (a.usual_name < b.usual_name) {
          return -1;
        }
        if (a.usual_name > b.usual_name) {
          return 1;
        }
        return 0;
      }
      array.sort(compare);

      /// variable to define end of table
      let nbSubstances = array.length;
      console.log("export de", nbSubstances, "substance(s)");
      let countSub = 1;

      array.forEach((value) => {
        let row = Array(indexHelper.length);
        for (let pas = 0; pas < indexHelper.length; pas++) {
          row[pas] = {
            v: "",
            s: {
              border: {
                right: { style: "thin", color: "000000" },
                left: { style: "thin", color: "000000" },
              },
            },
          };
          if (countSub === nbSubstances) {
            row[pas].s.border.bottom = { style: "thin", color: "000000" };
          }
        }
        countSub = countSub + 1;
        row[0].v = value.usual_name;
        row[1].v = value.ce;
        row[2].v = value.cas;
        for (const [theme, rule] of Object.entries(value.rules)) {
          for (const [ruleName, cleval] of Object.entries(rule)) {
            for (const [cle, valeur] of Object.entries(cleval)) {
              let index = indexHelper.indexOf(`${theme}_${ruleName}_${cle}`);
              row[index].v = valeur;
              if (cle === "présent") {
                row[index].s.alignment = { horizontal: "center" };
              }
            }
          }
        }
        dataToExcel.push(row);
      });

      /// create excel ///

      /// Create a new workbook
      const wb = XLSX.utils.book_new();

      // // // example style
      // // s: { font: { name: "Courier", sz: 24 } }
      // // s: { font: { bold: true, color: { rgb: "FF0000" } }
      // // s: { fill: { fgColor: { rgb: "E9E9E9" } }
      // // s: { alignment: { wrapText: true } }
      // // s: { font: { name: "arial" },
      // // alignment: { vertical: "center", horizontal: "center", wrapText: "1", // any truthy value here },
      // // border: { right: { style: "thin", color: "000000",}, left: {style: "thin", color: "000000",}, },

      // Create worksheet with rows; Add worksheet to workbook
      const ws = XLSX.utils.aoa_to_sheet(dataToExcel);

      // WIDTH of each column
      let wscols = [];
      wscols.push({ width: 40 });
      for (let i = 1; i < indexHelper.length; i++) {
        wscols.push({ width: 15 });
      }
      ws["!cols"] = wscols;

      // Merge Theme Header
      // EXEMPLE MERGE merge = [
      //   { s: { r: 0, c: 1 }, e: { r: 0, c: 2 } },
      //   { s: { r: 1, c: 1 }, e: { r: 1, c: 2 } },
      // ];

      /// MERGE
      let themesObj = {};
      headerThemeHelper.forEach((theme, i) => {
        if (!themesObj[theme]) {
          themesObj[theme] = { s: { r: 3, c: i }, e: { r: 3, c: 0 } };
        }
        themesObj[theme]["e"] = { r: 3, c: i };
      });
      // console.log("OBJ", themesObj);
      let rulesObj = {};
      headerHelper.forEach((rule, i) => {
        if (!rulesObj[rule]) {
          rulesObj[rule] = { s: { r: 4, c: i }, e: { r: 4, c: 0 } };
        }
        rulesObj[rule]["e"] = { r: 4, c: i };
      });
      // console.log("OBJ", rulesObj);

      const merge = [];
      Object.values(themesObj).forEach((value) => {
        merge.push(value);
      });
      Object.values(rulesObj).forEach((value) => {
        merge.push(value);
      });
      // console.log("MERGE :", merge);
      ws["!merges"] = merge;

      // console.log(ws);

      XLSX.utils.book_append_sheet(wb, ws, "data");
      // Write Excel file to browser
      XLSX.writeFile(wb, `exportBDSR_${date}_${hh}${mm}` + this.fileType);
    },
  },
};
</script>